var map = {
	"./GDQ-svarsstapel_00.gif": "c29f",
	"./GDQ-svarsstapel_10.gif": "d963",
	"./GDQ-svarsstapel_100.gif": "8b7e",
	"./GDQ-svarsstapel_20.gif": "1c4e",
	"./GDQ-svarsstapel_30.gif": "ed11",
	"./GDQ-svarsstapel_40.gif": "8638",
	"./GDQ-svarsstapel_50.gif": "f14f",
	"./GDQ-svarsstapel_60.gif": "6443",
	"./GDQ-svarsstapel_70.gif": "65cc",
	"./GDQ-svarsstapel_80.gif": "1585",
	"./GDQ-svarsstapel_90.gif": "3e61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cfa";